module.exports = __webpack_public_path__ + "static/media/Veredelung_Teaser.b88beed5.jpg";